import React, { useState } from 'react';
import './MarkAsCollectedTodo.scss';
import AppButton from 'src/components/base/Button/Button';
import MiniCheckBox from 'src/components/modules/MiniCheckBox/MiniCheckBox';
import { updateIfollowedUpTodo } from 'src/redux/services/loggingServices';
import { useDispatch } from 'react-redux';
import { clearModalContent } from 'src/redux/modules/modalEvent';
import { Logger } from 'src/services';
import { Todo} from 'src/latest/src/types';
import { TodoTypeEnums } from 'src/latest/src/constants/TodoType';
import { Typography } from "src/latest/src/components";

type MarkAsCollectedTodoType = {
  todo: Todo;
  onConfirm: () => void;
};

const MarkAsCollectedTodo: React.FC<MarkAsCollectedTodoType> = ({
  todo,
  onConfirm,
}) => {
  const [disableClearTodoBtn, setDisableClearTodoBtn] = useState(true);
  const [isAgree, setIsAgree] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const dispatch = useDispatch(); 

  const handleCheckBoxChange = () => {
    setIsAgree(!isAgree);
    setDisableClearTodoBtn(!disableClearTodoBtn);
  };

  const handleClearTodoBtnClick = () => {
    setDisableClearTodoBtn(true);
    setIsloading(true);
    createFollowUp();
  };

  const createFollowUp = async () => {
    const respObj = {
      follow_up_by: [TodoTypeEnums?.SELF],
      note: ``,
    };

    try {
      await updateIfollowedUpTodo(todo.id, respObj);
      dispatch(clearModalContent());
      onConfirm();
    } catch (e) {
      Logger.log('collect error', e);
    } finally { 
      setIsloading(false);
      setDisableClearTodoBtn(true);
      setIsAgree(false);
    }
  };

  return (
    <div className="mark-as-collected-todo-container">
      <div className="mark-as-collected-todo-container_title_text">
        <Typography className="mark-as-collected-todo-container_title_text_typo">
          This TO-DO will automatically be cleared when the invited
          adult, {todo?.participant_name}, signs the Consent Form. If needed,
          you can also manually clear this TO-DO here.
        </Typography>
      </div>
      <div className="mark-as-collected-todo-container_checkbox">
        <MiniCheckBox
          text={`I have already collected a Consent Form from
          ${todo?.participant_name} off platform`}
          isCheckFirst={true}
          isActive={isAgree}
          onClick={handleCheckBoxChange}
          value={isAgree}
          textClassName="required-consent-text"
        />
      </div>
      <div>
        <AppButton
          isProcessing={isLoading}
          disabled={disableClearTodoBtn}
          label={TodoTypeEnums?.CLEAR_TODO}
          onClick={handleClearTodoBtnClick}
        />
      </div>
    </div>
  );
};

export default MarkAsCollectedTodo;
